import React,{ useEffect } from "react";
import { connect } from "react-redux";
import SalaryTable from "./components/SalaryTable";

const EmployeeSalary = ({employeeId}) => {

	useEffect(() => {
	}, [employeeId]);
	
	return (
	    <div>
			<div className="grid h-full grid-cols-1 gap-4">
				<SalaryTable employeeId={employeeId} />
			</div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeSalary);